import type { FC } from 'react';
import React, { useMemo } from 'react';

import { getLocalTimeZone } from '@internationalized/date';

import { createProtectedContext } from '../lib';

export type TimeZoneData = { timeZone: string; isCustomTimeZone: boolean };

const timeZoneContextDefaultValue: TimeZoneData = {
    timeZone: getLocalTimeZone(),
    isCustomTimeZone: false,
};

export const TimeZoneContext = createProtectedContext<TimeZoneData>(
    'TimeZoneContext',
    timeZoneContextDefaultValue,
);

export type TimeZoneProviderProps = React.PropsWithChildren<
    Partial<Pick<TimeZoneData, 'timeZone'>>
>;

export const TimeZoneProvider: FC<TimeZoneProviderProps> = ({ timeZone, children }) => {
    const contextValue = useMemo(
        () =>
            timeZone
                ? { timeZone, isCustomTimeZone: timeZone !== getLocalTimeZone() }
                : timeZoneContextDefaultValue,
        [timeZone],
    );

    return <TimeZoneContext.Provider value={contextValue}>{children}</TimeZoneContext.Provider>;
};

export const useTimeZone = TimeZoneContext.useContext;
